// extracted by mini-css-extract-plugin
export default {"container":"ApplePayButton_container__qErNm"};